import React, { useMemo, useRef } from "react"
import { Box, Typography, Button, IconButton } from "@mui/material"
import CloudUploadOutlinedIcon from "@mui/icons-material/CloudUploadOutlined"
import CloseIcon from "@mui/icons-material/Close"

const ImageFileField = ({
    label,
    required,
    value,
    error,
    voiceiiTags,
    onChange,
    onClear,
    baseUrl,
}) => {
    const inputRef = useRef(null)

    const previewUrl = useMemo(() => {
        if (!value) return ""

        if (value instanceof File) {
            return URL.createObjectURL(value)
        }

        return `${baseUrl}${value}`.replace(/([^:]\/)\/+/g, "$1")
    }, [value, baseUrl])

    return (
        <Box className="e-image-file-field">
            <Typography className="e-image-file-field__label">
                {voiceiiTags(label)}
                {required && <span className="e-required-star">*</span>}
            </Typography>

            <input
                ref={inputRef}
                hidden
                type="file"
                accept="image/*"
                onChange={(e) => {
                    const file = e.target.files?.[0]
                    if (file) {
                        onChange(file)
                        e.target.value = ""
                    }
                }}
            />

            {!previewUrl ? (
                <Button
                    variant="outlined"
                    startIcon={<CloudUploadOutlinedIcon />}
                    onClick={() => inputRef.current?.click()}
                    className="e-image-file-field__upload-btn"
                >
                    {voiceiiTags("Upload Photo")}
                </Button>
            ) : (
                <Box className="e-image-file-field__preview-wrapper">
                    <Box className="e-image-file-field__image-wrapper">
                        <img
                            src={previewUrl}
                            alt="Patient"
                            className="e-image-file-field__preview"
                        />
                    </Box>

                    <IconButton
                        className="e-image-file-field__remove-btn"
                        onClick={onClear}
                    >
                        <CloseIcon />
                    </IconButton>
                </Box>
            )}

            {error && (
                <Typography className="e-image-file-field__error">
                    {error}
                </Typography>
            )}
        </Box>
    )
}

export default React.memo(ImageFileField)